// GENERATED AT BUILD TIME by scripts/gen-environment.sh — do not edit.
// The version committed to git holds local-dev values only.
export const environment = {
  production: true,
  apiUrl: 'https://backend.nikocrm.net/api',
  cognitoUserPoolId: 'us-east-1_M5uAPEe3z',
  cognitoClientId: '3ti0r765u9al4d8k89cflec58k',
  awsRegion: 'us-east-1',
};
